@use '../../../../../styles/Colors.scss' as Colors;
@use '../../../../../styles/Constants.scss' as Constants;

$var-border: 1px solid Colors.$col-greyFontLight;

@mixin status-label {
	text-align: center;
	padding: 0 Constants.$val-spacing-m;
	border-radius: Constants.$val-borderRadius;
	font-weight: bold;
	font-size: Constants.$val-fontSizeSmall;
	min-width: 100px;
	text-overflow: hidden;
	background-color: Colors.$col-design-grey12;
}

.order-table {

	&__sub-text {
		color: Colors.$col-greyFontLight;
		font-size: Constants.$val-fontSizeSmall;
	}

	&__new-status {
		@include status-label;
		color: Colors.$col-blue;
	}

	&__in-progress-status {
		@include status-label;
		color: Colors.$col-orangeBorder;
	}

	&__completed-status {
		@include status-label;
		color: Colors.$col-green;
	}
}

.tooltip-table {
	width: 100%;
	border-collapse: separate;
  }
  
.tooltip-table th,
.tooltip-table td {
	border-bottom: $var-border;
	padding: Constants.$val-spacing-xxxs Constants.$val-spacing-xxs ;
	border-left: $var-border;
}
  
.tooltip-table th {
	text-align: left;
	border-top: $var-border;
	font-size: Constants.$val-fontSizeSmall;
}

.tooltip-table th:last-child {
	text-align: right;
	border-right: $var-border;
}
  
.tooltip-table td:last-child {
	text-align: right;
	border-right: $var-border;
}

.tooltip-table td:last-child {
	border-right: $var-border;
	border-bottom: $var-border;
}

.tooltip-table th:last-child,
.tooltip-table td:last-child {
	white-space: nowrap;
	min-width: 50px;
	width: fit-content;
}

.table-filter {
	display: flex;
}

.completed-filter {
	margin-right: 8px;
	display: flex;
	flex-direction: row;
}

.completed-filter-button {
	border: 1px solid Colors.$col-greyMid;
	border-radius: Constants.$val-borderRadius;
	border-top-right-radius: 0;
	border-bottom-right-radius: 0;
	display: flex;
	align-items: center;
	background: Colors.$col-white;
	width: 200px;
}